import { ChkHeader } from '@apps/checkout-components';

import { HEADER_TEXT } from './Header.constants';

export const Header = () => <ChkHeader>{HEADER_TEXT}</ChkHeader>;
